import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Badge } from '../../../components/ui/badge';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../components/ui/dialog';
import { Key } from 'lucide-react';
import { formatDateTime } from '../../../lib/utils';

export function ResetPasswordDialog({ dialog, onChange, newPassword, onNewPasswordChange, onConfirm }) {
    return (
        <Dialog open={dialog.open} onOpenChange={(open) => onChange({ open, user: dialog.user })}>
            <DialogContent className="bg-gray-800 border-border text-white">
                <DialogHeader>
                    <DialogTitle>Réinitialiser le mot de passe</DialogTitle>
                    <DialogDescription className="text-muted-foreground">
                        Nouveau mot de passe pour {dialog.user?.email}
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label>Nouveau mot de passe</Label>
                        <Input
                            type="text"
                            value={newPassword}
                            onChange={(e) => onNewPasswordChange(e.target.value)}
                            className="bg-gray-700 border-gray-600"
                            placeholder="Min. 8 caractères"
                            data-testid="new-password-input"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onChange({ open: false, user: null })}
                        className="border-gray-600"
                    >
                        Annuler
                    </Button>
                    <Button onClick={onConfirm} data-testid="confirm-reset-password">
                        <Key className="w-4 h-4 mr-2" />
                        Réinitialiser
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export function UserDetailDialog({ dialog, onChange }) {
    return (
        <Dialog open={dialog.open} onOpenChange={(open) => onChange({ open, user: dialog.user })}>
            <DialogContent className="bg-gray-800 border-border text-white max-w-2xl">
                <DialogHeader>
                    <DialogTitle>Détails utilisateur</DialogTitle>
                </DialogHeader>
                {dialog.user && (
                    <div className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <p className="text-sm text-muted-foreground">Nom</p>
                                <p className="font-medium">{dialog.user.first_name} {dialog.user.last_name}</p>
                            </div>
                            <div>
                                <p className="text-sm text-muted-foreground">Email</p>
                                <p className="font-medium">{dialog.user.email}</p>
                            </div>
                            <div>
                                <p className="text-sm text-muted-foreground">Téléphone</p>
                                <p className="font-medium">{dialog.user.phone || '-'}</p>
                            </div>
                            <div>
                                <p className="text-sm text-muted-foreground">Rôle</p>
                                <Badge>{dialog.user.role}</Badge>
                            </div>
                            <div>
                                <p className="text-sm text-muted-foreground">Statut</p>
                                <Badge variant={dialog.user.is_active ? 'default' : 'destructive'}>
                                    {dialog.user.is_active ? 'Actif' : 'Inactif'}
                                </Badge>
                            </div>
                            <div>
                                <p className="text-sm text-muted-foreground">Inscription</p>
                                <p className="font-medium">{formatDateTime(dialog.user.created_at)}</p>
                            </div>
                        </div>
                        {dialog.user.agency && (
                            <div className="p-4 rounded-lg bg-gray-700/50">
                                <p className="text-sm text-muted-foreground mb-2">Agence</p>
                                <p className="font-medium">{dialog.user.agency.name}</p>
                                <p className="text-sm text-muted-foreground">{dialog.user.agency.email}</p>
                            </div>
                        )}
                        {dialog.user.mandates_count !== undefined && (
                            <div>
                                <p className="text-sm text-muted-foreground">Nombre de mandats</p>
                                <p className="font-medium">{dialog.user.mandates_count}</p>
                            </div>
                        )}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
